import { executeNetworkAsync } from "../../helper/handler/network";
import { CreatePasswordPayload } from "../../../components/Auth/CreatePassword/CreatePasswordFormSchema";
import { clientAxiosInstance } from "../../types/swrFetcher";

export const createPassword = async (payload: CreatePasswordPayload) => {
  const networkCall = async () =>
    await clientAxiosInstance().patch(`/api/auth/createPassword`, payload);

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
